
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post13() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Dúvida saúde - geral - Colesterol Alto: Gorduras boas e ruins</title>
        <meta 
          name="description" 
          content="Na minha trajetória desde que descobri o colesterol alto 3 mudanças foram importantes: perder peso, melhorar minha alimentação e começar a fazer exercício físico. Cada uma delas ajuda a sustentar as outras e a melhorar minha saúde.

Sobre alimentação saudável, em particular, aprendi sobre gorduras boas e ruins para nós.

Gorduras boas: São gorduras mono-saturadas, poli-saturadas, omega-3 e omega-6. Ela diminuem o colesterol ruim (LDL) e aumentam o colesterol bom (HDL). A gente consegue consumir elas em alimentos como nozes, abacates e peixes. Essas são super importantes de comer!

Gorduras para evitar: gordura trans, colesterol e gorduras saturadas.

1) Gordura trans: É a gordura mais perigosa que consumimos. É usada como preservativo para longo tempo de vida útil na prateleira. Deve ser evitada completamente.

2_ Colesterol: Gema de ovo é a principal fonte. Conseguimos evitar comendo somente a clara do ovo.

3) Gordura saturada: Gordura encontrada mais facilmente nas comidas que consumimos. Evitar ao máximo. Ideal buscar comidas com 0g a 0.5g dessa gordura.

O ideal e o que eu tento fazer é evitar e substituir as gorduras ruins por gorduras boas: frutas, vegetais, abacate, nozes, feijão, lentilha e peixe são excelentes opções. É importante utilizar também azeite de oliva ao invés de outros óleos comuns.

Adicionalmente, aprendi os benefícios de evitar carne vermelha, carnes processadas, queijos, manteigas, comidas fritas e que contém muita gordura saturada.

Espero que esse conhecimento seja útil para vocês assim como é para mim!"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            L. Carrol &#183; 24/07/2024
          </p>
        </div>
        <p className="heading4 bottom-margin-s">Colesterol Alto: Gorduras boas e ruins</p>


        <p className="body content bottom-padding-s">
            Na minha trajetória desde que descobri o colesterol alto 3 mudanças foram importantes: perder peso, melhorar minha alimentação e começar a fazer exercício físico. Cada uma delas ajuda a sustentar as outras e a melhorar minha saúde.<br/><br/>Sobre alimentação saudável, em particular, aprendi sobre gorduras boas e ruins para nós.<br/><br/>Gorduras boas: São gorduras mono-saturadas, poli-saturadas, omega-3 e omega-6. Ela diminuem o colesterol ruim (LDL) e aumentam o colesterol bom (HDL). A gente consegue consumir elas em alimentos como nozes, abacates e peixes. Essas são super importantes de comer!<br/><br/>Gorduras para evitar: gordura trans, colesterol e gorduras saturadas.<br/><br/>1) Gordura trans: É a gordura mais perigosa que consumimos. É usada como preservativo para longo tempo de vida útil na prateleira. Deve ser evitada completamente.<br/><br/>2_ Colesterol: Gema de ovo é a principal fonte. Conseguimos evitar comendo somente a clara do ovo.<br/><br/>3) Gordura saturada: Gordura encontrada mais facilmente nas comidas que consumimos. Evitar ao máximo. Ideal buscar comidas com 0g a 0.5g dessa gordura.<br/><br/>O ideal e o que eu tento fazer é evitar e substituir as gorduras ruins por gorduras boas: frutas, vegetais, abacate, nozes, feijão, lentilha e peixe são excelentes opções. É importante utilizar também azeite de oliva ao invés de outros óleos comuns.<br/><br/>Adicionalmente, aprendi os benefícios de evitar carne vermelha, carnes processadas, queijos, manteigas, comidas fritas e que contém muita gordura saturada.<br/><br/>Espero que esse conhecimento seja útil para vocês assim como é para mim!
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/13')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  4 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Muito bom, parabéns!
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    T. Estudante &#183; 30/07/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/13')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Mario César &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/97-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. Estou bastante triste, descobri que estou com catarata por conta da diabete segundo o oftalmologista. Não consigo entender muito bem, mantenho a glicose controlada, jejum 105, prandial deu até menos, 100 glicada 6.4. Estou preocupado.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/97')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            6 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Claudia Coimbra &#183; 13/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/83-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. Preciso de ajuda. Quando tem moleza no corpo e vontade de dormir o dia todo é porque a diabetes está baixa?<br/>Meu marido tem diabates, e as vezes ele dorme o dia todo.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/83')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            5 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Maria Schwed &#183; 08/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/41-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal!!<br/>Eu ando bem esgotada, qualquer coisa que vou fazer fico super cansada. Não sei se é devido a diabete tipo 2, mas quero melhorar isso. Eu trabalho e tenho 48 anos. Você tem algum dica do que eu possa fazer?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/41')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    L. Carrol &#183; 24/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/9-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Sobre perda e controle do peso  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Controlar meu peso foi a primeira coisa onde foquei depois do meu diagnóstico com colesterol alto. Eu estava com obesidade, e precisava reduzir meu peso de maneira sustentável e saudável. Com isso em mente, estudei e apliquei o que aprendi. <br/><br/>Algumas coisas que não sabia, mas que me aproximaram da realidade, são que pessoas que estão acima do seu peso ideal tem:<br/><br/>1) Maior risco de tornarem-se diabéticos.<br/>2) Maior risco de tornarem-se hipertensos.<br/>3) Maior risco de câncer de mama.<br/>4) Maior risco de câncer de cólon.<br/>5) Existe uma correlação direta entre sobrepeso e doenças cardíacas.<br/><br/>Com conhecimento sobre esses pontos comecei a trabalhar em desenvolver uma alimentação que me permitisse perder peso, e sustentar meu novo peso saudável. Notem aqui algo super importante, que nem sempre é evidente: a sua dieta para perda de peso precisa ser a sua nova rotina de alimentação como um todo, e não algo que você vai fazer algumas semanas enquanto perde peso, e depois vai parar e voltar para o que era antes. Se isso acontecer, todo o peso que você perdeu vai voltar em pouco tempo e com alguns kilos a mais.<br/><br/>PONTO CHAVE: A dieta de perda de peso precisa se tornar a nova rotina de alimentação como um todo.<br/><br/>Então, o ponto chave é: sua alimentação para perda de peso precisa ser sua alimentação para sustentar aquele peso. Ou seja, precisa ser sua nova educação alimentar, seu novo e permanente estilo de vida para alimentação.<br/><br/>Para montar seu novo estilo de vida alimentar é legal ter a ajuda de um nutricionista que te conhece. Mas alguns pontos gerais que eu usei e podem ser úteis:<br/><br/>O número de calorias que você consome menos o número de calorias que você queima determina se você irá ganhar ou perder peso. É importante focar em comidas que irão te dar a sensação de estar cheio/satisfeito com o menor número de calorias: comidas ricas em fibra, frutas e vegetais são ótimas opções, e devem fazer parte integral da nova alimentação (foque em no mínimo 3 frutas por dia!).<br/><br/>Corte os lanches durante o dia e a sobremesa enquanto você estiver tentando perder peso. E após ter chegado no seu peso ideal, esses lanches devem ser frutas.<br/><br/>Cuidado com o tamanho das porções. Mas coma quantos vegetais e frutas quiser, esses são livres!<br/><br/>Evite frituras. Elas adicionam cerca de um terço a mais de calorias. Prefira grelhados ou assados.<br/><br/>Faça exercícios: suas chances de perder peso e manter o peso ideal são muito melhores se você se exercitar. Até mesmo uma caminhada algumas vezes por dia é 1000 vezes melhor do que ficar sentado na frente da TV.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/9')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Joana Ling &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/92-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. Estou com glicada 8.9. Será q consigo reverter? Estou grávida e fiquei muito triste com essa descoberta
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/92')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
